<template>
  <footer id="footer" v-show="this.showFooter">
    <div
      class="bg-wrapper"
      :style="'background-image: url(' + $APIURL +'../files/images/backgrounds/fruehling--background-footer.png)'"
    >
      <nav class="footer-navigation content-wrapper">
        <div class="footer-logo">
          <a href="https://www.amecke.de/">
            <img
              :src="'https://www.amecke.de/files/images/Aktionen/mehr-leben/logo2022.svg'"
              alt="Amecke"
              id="footerlogo"
            />
          </a>
        </div>
        <ul>
          <li v-if="blniscampaingsite">
            <a href="https://www.amecke.de/">Zur Amecke Website</a>
          </li>
          <li>
            <a @click="goToPage('/kontakt/kontaktformular')">Kontakt</a>
          </li>
          <li>
            <a @click="goToPage('/datenschutzerklaerung')">Datenschutzerklärung</a>
          </li>
          <li>
            <a @click="goToPage('/impressum')">Impressum</a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>

<script>
// TODO: DMA - bibliotheken in app.js inkludieren
import Base from "./Base.vue";
export default {
  extends: Base,
  data() {
    return {
      submitted: false,
      blniscampaingsite: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.iscampaingsite();
    }, 2000);
  },
  methods: {
    goToPage(path) {
      this.$router.push(path);
    },
    validateFormAndSendFooterForm() {
      let myForm = document.getElementById("footerform");
      let formData = new FormData();
      let formDataelement = new FormData(myForm);
      for (let field of formDataelement.keys()) {
        formData.append(field, formDataelement.get(field));
      }

      let apiurl = this.$APIURL + this.$APIVERSION + "/submitfooterform";

      let callmethod = document
        .getElementById("footerform")
        .getAttribute("method")
        .toLowerCase();

      axios
        .post(apiurl, formData)
        .then(response => {
          if (response.data.data == true) {
            myForm.reset();
            this.submitted = true;
            setTimeout(() => {
              this.submitted = false;
            }, 10000);
          }
        })
        .catch(error => {});
    },
    iscampaingsite() {
      this.blniscampaingsite = document.body.classList.contains(
        "site-campaign"
      );
      return this.blniscampaingsite;
    }
  },
  watch: {
    $route(to, from) {
      this.showFooter = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";
@import "@/scss/mixins.scss";

#footer {
  // bottom: 0;
  // position: absolute;
  // width: 100%;
  .content-wrapper {
    margin-bottom: 0;
  }
  clear: both;
  .bg-wrapper {
    padding-top: 50px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
  }

  .footer-form {
    width: 100%;

    @include min-screen($screen-min-m) {
      form {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .form-group:not(.combined-textarea) {
          flex: 1 48%;

          &:nth-child(2) {
            margin-left: 2%;
          }
        }

        .form-group {
          &.combined-textarea {
            flex: 1 100%;
          }
        }
      }
    }
  }

  .footer-logo {
    margin: 0 auto;
    width: 165px;
    max-width: 165px;

    @include min-screen($screen-min-m) {
      display: inline-block;
      margin: 0;
    }
  }

  .footer-navigation {
    padding-top: 10px;
    padding-bottom: 30px;

    @include min-screen($screen-min-m) {
      padding-top: 20px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    ul {
      color: $color-green;
      list-style: none;
      margin: 0;
      padding: 0;

      @include min-screen($screen-min-m) {
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        align-self: center;
      }

      li {
        @include font-TheMix("bold");
        padding: 0 10px;
        text-align: center;

        @include min-screen($screen-min-m) {
          text-align: left;
        }
      }
    }
  }
}
</style>